<template>
  <div>
    <Teleport to="#settings-group-header">
      <T>Локальный сервер</T>
    </Teleport>  

    <Teleport to="#settings-group-actions">
      <v-btn test-tag="tag-278"
        text
        color="primary"
        @click="save"
        :loading="loading"
        :disabled="loading"
      >
        <v-icon>mdi-content-save</v-icon>
        <T>Сохранить</T>
      </v-btn>
    </Teleport>

    <div class="mt-6 mb-0">
      <strong><T>Сервер</T></strong>
      <Server :loading="loading" :config="$store.getters.config.local_server" ref="serv"/>
    </div>

    <hr />

    <div class="mt-5 mb-5">
      <strong><T>Логирование</T></strong>
      <Logging :loading="loading" :config="$store.getters.config.log" ref="log"/>
    </div>
  </div>
</template>

<script>

import Teleport from 'vue2-teleport'
import Server from '../../components/settings/server'
import Logging from '../../components/settings/logging'


export default {
  data: () => ({
    loading: false
  }),
  methods: {
    async save(){
      this.loading = true
      try {
        let new_config = {
          local_server: this.$refs.serv.submit(),
          log: this.$refs.log.submit()
        }

        if (new_config.local_server.locale != this.$store.getters.config.local_server.locale) {
          
          await this.$store.dispatch('setLocale', new_config.local_server.locale)
          delete new_config.local_server.locale

          this.$store.dispatch('throwMessage', {
            message_data: this.$t('Изменен язык интерфейса. Кликните на это уведомление для перезагрузки страницы.'),
            message_class: 'success',
            resolver: async () => {
              location.reload()
            }
          })
        }

        
        await this.$store.dispatch('updateConfig', new_config)

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Изменения сохранены'),
          message_class: 'success'
        })

      } catch (e) {
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: `${e.message}`,
          message_class: 'error'
        })
        this.loading = false
      } finally {
        this.loading = false
      }
    }
  },
  components: {
    Teleport,
    Server,
    Logging
  }
}
</script>

<style>
hr {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 0 0 15px 0;
}

</style>